import {
  BANNER_PADDING_TOP,
  PAGE_MARGIN_TOP,
} from './retailLinesheetsBanner.constants'

export const formatPhpLinesheetsPage = () => {
  const pageElement = document.querySelector('.page') as HTMLElement | null
  const sideBarElement = document.querySelector(
    '.sidebar',
  ) as HTMLElement | null
  const contentElement = document.querySelector(
    '.content',
  ) as HTMLElement | null

  // When coming from React to the Retailer Linesheet page, PHP is doing a redirection,
  // which is showing a white page, we need to check this case and hide the banner, because
  // it will be the only thing visible in the white page
  const isValidPage =
    pageElement &&
    contentElement &&
    sideBarElement &&
    sideBarElement.clientHeight > 0

  if (isValidPage) {
    pageElement.style.paddingTop = `${BANNER_PADDING_TOP}px`
    sideBarElement.style.marginTop = `${PAGE_MARGIN_TOP}px`
    contentElement.style.marginTop = `${PAGE_MARGIN_TOP}px`
  }

  return isValidPage
}
